import axios from "axios";
import {materialCloudServicesPath} from "../../../Constants";

const jobRestUrl = materialCloudServicesPath + '/user/job-metric-milling-material'

export default class JobMetricMilling {

    static async getJobMetricMillingByMaterialId(materialId) {
        return axios.get(jobRestUrl + '/by-material-id-for-catalog'
            + '?materialId=' + materialId);
    }
}